export const MASONRY_RESULT_LIMIT = 10_000;
export const MASONRY_METADATA_PADDING = 8;

export function masonryColumns(width, gridSize = 'm', mobile = false) {
    const size = ['xs', 's', 'm', 'l', 'xl'].includes(gridSize) ? gridSize : 'm';
    const gutter = mobile ? 5 : 15;
    const minimumWidth = {xs: 100, s: 150, m: 200, l: 350, xl: 500}[size];
    const count = mobile ? {xs: 5, s: 4, m: 3, l: 2, xl: 1}[size] :
        Math.max(1, Math.floor((width + gutter) / (minimumWidth + gutter)));
    const fittedWidth = Math.max(1, (width - gutter * (count - 1)) / count);
    // Match Grid's desktop sizes. Stretching both L and XL to fill two columns
    // would otherwise make their controls produce exactly the same layout.
    return {count, gutter, width: mobile ? fittedWidth : Math.min(minimumWidth, fittedWidth)};
}

// Reserve media space before the derivative loads, including during video hover.
export function masonryMediaHeight(asset, width) {
    const w = Number(asset?.width), h = Number(asset?.height);
    const height = width * h / w;
    return w > 0 && h > 0 && Number.isFinite(w) && Number.isFinite(h) && Number.isFinite(height) ?
        Math.min(width * 4, Math.max(Math.min(48, width), height)) : width;
}

export function masonryMetadataLayout(asset, {showRating, showFilenames, showHeadline}) {
    const headline = !!showHeadline && !!asset.headline?.trim();
    const rows = Number(!!showRating) + Number(!!showFilenames) + Number(headline);
    return {headline, rows, height: rows ? MASONRY_METADATA_PADDING * 2 + rows * 22 + (rows - 1) * 2 : 0};
}

export function masonryCardHeight(asset, width, settings, mediaHeight) {
    if(!asset.id) return mediaHeight ?? width; // Skeletons render no metadata rows or card border.
    // The cover overlaps the top border; match the observer's integer offsetHeight.
    return Math.round((mediaHeight ?? masonryMediaHeight(asset, width)) + 1 + masonryMetadataLayout(asset, settings).height);
}


// Match the positioner's ID-plus-occurrence identity without storing a stale
// result index in the shared cursor state.
export function masonryCursorKey(ids, index) {
    const id = ids[index];
    if(id == null || !Number.isInteger(index)) return undefined;
    let occurrence = 0;
    for(let i = 0; i <= index; i++) if(ids[i] === id) occurrence++;
    return `asset-${id}-${occurrence}`;
}

export function masonryNeighbor(positioner, index, direction, length) {
    if(!length) return -1;
    if(index < 0) return 0;
    if(direction === 'prev') return Math.max(0, index - 1);
    if(direction === 'next') return Math.min(length - 1, index + 1);
    if(positioner.neighbor) return positioner.neighbor(index, direction);
    const current = positioner.get(index);
    if(!current) return -1;
    let nearest = index, distance = Infinity;
    for(let i = 0; i < length; i++) {
        const cell = positioner.get(i);
        if(!cell || cell.left !== current.left) continue;
        const delta = direction === 'down' ? cell.top - current.top : current.top - cell.top;
        if(delta > 0 && delta < distance) {nearest = i; distance = delta}
    }
    return nearest;
}
